import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Home from '../Pages/Home';
import PageNotFound from '../Pages/PageNotFound';
import DayTourListingPage from '../Pages/DayTourListingPage';
import RoundTourListing from '../Pages/RoundTourListingPage';
import SpecialTourListing from '../Pages/SpecialTourPage';
import MaldiveListingPage from '../Pages/MaldiveListingPage';
import SearchResultPage from '../Pages/SearchResultPage';
import ThingsListingPage from '../Pages/ThingsListingPage';
import RentCarListing from '../Pages/ListPage/RentCarListing';
import BlogListing from '../Pages/ListPage/BlogListing';
import CustomerCare from '../Pages/CustomerCare';
import TravelEssense from '../Pages/TravelEssense';
import AboutUs from '../Pages/AboutUs';
import ContactUs from '../Pages/ContactUs';
import DayTourDetails from '../Pages/DetailsPage/DayTourDetails';
import RoundTourDetails from '../Pages/DetailsPage/RoundTourDetails';
import MadivePackDetails from '../Pages/DetailsPage/MadivePackDetails';
import MadiveResortDetails from '../Pages/DetailsPage/MadiveResortDetails';
import ThingsToDoDetails from '../Pages/DetailsPage/ThingsToDoDetails';
import Transfers from '../Pages/DetailsPage/Transfers';
import RentCarDetailsPage from '../Pages/DetailsPage/RentCarDetails';
import BlogDetailsPage from '../Pages/DetailsPage/BlogDetails';
import ConfirmReserve from '../Pages/Checkout/ConfirmReserve';
import MaldiveResConfirmReserve from '../Pages/Checkout/MaldiveResConfirmReserve';
import MaldivePackConfirmReserve from '../Pages/Checkout/MaldivePackConfirmReserve';
import TransferReserve from '../Pages/Checkout/TransferReserve';
import RentCarInfoReserve from '../Pages/Checkout/RentCarReserve';
import PaySucess from '../Pages/PaySucess';
import BookingSucess from '../Pages/BookingSucess';
import HyperLinkList from '../Pages/ListPage/HyperLinkList';

export default () => (
    <BrowserRouter basename="/">
        <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/day-tours" exact component={DayTourListingPage} />
            <Route path="/day-tours/:peram/:id" exact component={DayTourDetails} />
            <Route path="/round-tours" exact component={RoundTourListing} />
            <Route path="/round-tours/:cat/:name" exact component={RoundTourDetails} />
            <Route path="/special" exact component={SpecialTourListing} />
            <Route path="/maldives" exact component={MaldiveListingPage} />
            <Route path="/maldives/packages/:peram" exact component={MadivePackDetails} />
            <Route path="/maldives/resorts/:peram" exact component={MadiveResortDetails} />
            <Route path="/allSearchResult" exact component={SearchResultPage} />
            <Route path="/things-to-do" exact component={ThingsListingPage} />
            <Route path="/things-to-do/:peram" exact component={ThingsToDoDetails} />
            <Route path="/links/:type/:peram" exact component={HyperLinkList} />
            <Route path="/transport" exact component={RentCarListing} />
            <Route path="/transport/:peram" exact component={RentCarDetailsPage} />
            <Route path="/transport/confirm/reserve" exact component={RentCarInfoReserve} />
            <Route path="/blog" exact component={BlogListing} />
            <Route path="/blog/:peram" exact component={BlogDetailsPage} />
            <Route path="/customer-care" exact component={CustomerCare} />
            <Route path="/travel-essential" exact component={TravelEssense} />
            <Route path="/about-us" exact component={AboutUs} />
            <Route path="/contact-us" exact component={ContactUs} />
            <Route path="/vehicle-transfers" exact component={Transfers} />
            <Route path="/vehicle-transfers/confirm-reserve" exact component={TransferReserve} />
            <Route path="/confirm-reserve" exact component={ConfirmReserve} />
            <Route path="/maldive/resort/confirm-reserve" exact component={MaldiveResConfirmReserve} />
            <Route path="/maldive/package/confirm-reserve" exact component={MaldivePackConfirmReserve} />
            <Route path="/success" exact component={PaySucess} />
            <Route path="/booking-success" exact component={BookingSucess} />
            <Route path="/404" exact component={PageNotFound} />
            <Route path="*" exact component={PageNotFound} />
        </Switch>

    </BrowserRouter>
);
